import { CircularProgress, DialogHandler, EEditorType } from "@cakemail-org/ui-components-v2"
import { useEffect } from "react"
import { useTranslation } from "react-i18next"
import { updateFormLayoutOptions } from "../../../../container/forms/utils"
import "./styles.scss"
import { TFormContentDialog } from "./types"


export function showFormContentDialog({ resolve, reject, args, getContentContext, editorType }: TFormContentDialog) {
    DialogHandler.show({
        className: "editorFormsContentDialog",
        //managedByContent: true,
        content: <FormContentDialog resolve={resolve} reject={reject} args={args} getContentContext={getContentContext} editorType={editorType} />,
    })
}

export function FormContentDialog({ resolve, reject, args, getContentContext, editorType }: TFormContentDialog) {
    const { t } = useTranslation()

    useEffect(() => {
        if (editorType === EEditorType.popUpDesigner || editorType === EEditorType.pageDesigner) {
            const context = getContentContext()
            const baseStructure = {
                "structure": {
                    "attributes": {},
                    "fields": {},
                    "layout": [],
                    "title": "",
                    "description": ""
                }
            }
            updateFormLayoutOptions({
                content: { form: baseStructure },
                listId: context.list?.id as number,
                submissionUrl: context.formAction as string,
                recaptchaSiteKey: context.recaptchaSiteKey
            }).then((content) => {
                resolve(content.form)
            }).catch(() => {
                DialogHandler.show({ type: "error", title: t("general-error-action") })
                reject("error")
            }).finally(() => {
                DialogHandler.hide()
            })
        }
    }, [])

    /*
    async function handleInjectHtml(form: SummaryEnhancedFormModel | FormModel) {
        if (form instanceof SummaryEnhancedFormModel) {
            return form.render().then((content) => {
                return extractBodyContentFromHtml(content)
            }).catch(() => {
                DialogHandler.show({ type: "error", title: t("general-error-action") })
                reject("error")
            })
        } else {
            return form.content.embedded
        }
    }

    function handleAddSnippet(form: SummaryEnhancedFormModel | FormModel) {
        if (form instanceof SummaryEnhancedFormModel) {
            resolve({
                type: 'html',
                value: {
                    html: `<div style="padding: 12px; 0">${buildFormScript({ form })}</div>`
                }
            })
        } else {
            resolve({
                type: 'html',
                value: {
                    html: form.content.embedded
                }
            })
        }
        OverlayHandler.hide()
    }
    */
    {/*<ContentSectionContainer><FormsListing
            extraTopActions={[
                <Button
                    key="close"
                    color="shade150"
                    onClick={() => {
                        reject("close")
                        OverlayHandler.hide()
                    }}>{t("general-close")}
                </Button>
            ]}
            listMainButton={{
                text: t("general-inject-html"),
                onClick: (form: SummaryEnhancedFormModel | FormModel) => {
                    handleInjectHtml(form).then((html) => {
                        resolve({
                            type: 'html',
                            value: {
                                html: html
                            }
                        })
                        OverlayHandler.hide()
                    }).catch(() => {
                        DialogHandler.show({ type: "error", title: t("general-error-action") })
                        reject("error")
                    })
                }
            }}
            listActions={[
                {
                    text: t("general-inject-snippet"),
                    onClick: handleAddSnippet
                }
            ]}
        /> </ContentSectionContainer>*/}

    return <CircularProgress />

}
